import { useEffect, useState } from 'react'
import { getViewsList } from '../utils/api'
import { C, fontStack } from '../constant/theme'

// Modal listing who viewed a trip or a media item, and when. Every view is its
// own row (repeat views by the same person show serially), newest first.
export default function ViewsModal({ slug, target, onClose }) {
  const [views, setViews] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    let active = true
    setViews(null)
    setError('')
    getViewsList(slug, target.type, target.id)
      .then((v) => active && setViews(v))
      .catch(() => active && setError('Could not load views.'))
    document.body.style.overflow = 'hidden'
    return () => {
      active = false
      document.body.style.overflow = ''
    }
  }, [slug, target])

  return (
    <div style={S.backdrop} onClick={onClose}>
      <div style={S.card} onClick={(e) => e.stopPropagation()}>
        <div style={S.head}>
          <div style={{ minWidth: 0 }}>
            <div style={S.title}>Views</div>
            <div style={S.sub}>{target.label}</div>
          </div>
          <button style={S.close} onClick={onClose}>✕</button>
        </div>

        <div style={S.bodyArea}>
          {error ? (
            <div style={S.muted}>{error}</div>
          ) : !views ? (
            <div style={S.muted}>Loading…</div>
          ) : views.length === 0 ? (
            <div style={S.muted}>No views yet.</div>
          ) : (
            <>
              <div style={S.count}>{views.length} {views.length === 1 ? 'view' : 'views'}</div>
              <div>
                {views.map((v, i) => (
                  <div key={i} style={{ ...S.row, borderTop: i === 0 ? 'none' : `1px solid ${C.cardBorder}` }}>
                    <div style={S.avatar}>{(v.userName || '?').trim().charAt(0).toUpperCase() || '?'}</div>
                    <div style={{ minWidth: 0, flex: 1 }}>
                      <div style={S.name}>{v.userName || 'Unknown'}</div>
                      <div style={S.time}>{formatTime(v.createdAt)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

function formatTime(ms) {
  try {
    return new Date(ms).toLocaleString(undefined, {
      year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
    })
  } catch {
    return ''
  }
}

const S = {
  backdrop: { position: 'fixed', inset: 0, background: 'rgba(8,14,24,0.55)', zIndex: 11000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, fontFamily: fontStack },
  card: { width: '100%', maxWidth: 440, maxHeight: '80vh', background: C.card, borderRadius: 16, border: `1px solid ${C.cardBorder}`, boxShadow: '0 12px 50px rgba(8,14,24,.4)', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  head: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, padding: '16px 18px', borderBottom: `1px solid ${C.cardBorder}` },
  title: { fontSize: 16, fontWeight: 800, color: C.text },
  sub: { fontSize: 13, color: C.textSoft, marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  close: { flexShrink: 0, width: 30, height: 30, borderRadius: '50%', border: 'none', background: '#d0d8e4', color: C.text, cursor: 'pointer', fontSize: 14 },
  bodyArea: { overflowY: 'auto', padding: '8px 18px 16px' },
  count: { fontSize: 12.5, fontWeight: 700, color: C.muted, textTransform: 'uppercase', letterSpacing: '.04em', margin: '10px 0 6px' },
  muted: { color: C.textSoft, fontSize: 14, padding: '18px 0', textAlign: 'center' },
  row: { display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0' },
  avatar: { width: 34, height: 34, borderRadius: '50%', flexShrink: 0, background: C.navy2, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 14 },
  name: { fontSize: 14.5, fontWeight: 600, color: C.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  time: { fontSize: 12.5, color: C.textSoft, marginTop: 1 },
}
